import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { makeQuickFetchRequest } from 'marketing-platform-lib/utils/quickFetch';
export const FETCH_PROPERTY_GROUPS_FIELD_NAME = 'fetchPropertyGroups';
export const FETCH_PROPERTY_GROUPS_QUERY = registerQuery({
  fieldName: FETCH_PROPERTY_GROUPS_FIELD_NAME,
  args: ['objectTypeId'],
  fetcher({
    objectTypeId
  }) {
    const quickFetchName = `fetch-crm-properties-${objectTypeId}`;
    const propertyGroupsRequest = () => http.get(`/properties/v4/groups/${objectTypeId}?includeProperties=true`);
    return makeQuickFetchRequest({
      makeRequestFn: propertyGroupsRequest,
      requestName: quickFetchName
    });
  }
});
export default function useFetchPropertyGroups(objectTypeId, {
  skip
} = {
  skip: false
}) {
  const _useQuery = useQuery(FETCH_PROPERTY_GROUPS_QUERY, {
      variables: {
        objectTypeId
      },
      skip
    }),
    {
      data
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  return useMemo(() => Object.assign({
    data: data && FETCH_PROPERTY_GROUPS_FIELD_NAME in data ? data[FETCH_PROPERTY_GROUPS_FIELD_NAME].results || [] : []
  }, rest), [data, rest]);
}